import { claimsQueryKeys as claimsBaseQueryKeys } from '@eigtech/ui-shared-claims-lib'
import { portalsQueryKeys } from '../portals'

export const claimsQueryKeys = {
  ...claimsBaseQueryKeys,
  list: () => [...portalsQueryKeys.listActive(), 'claims'],
  mapboxLocation: (claimNumber: string) => [
    ...claimsQueryKeys.detail(claimNumber),
    'mapboxLocation',
  ],
}
